"use strict";

exports.__esModule = true;
exports.getFieldValue = exports.getDay = exports.getDate = exports.getAddress = exports.formatPhoneNumber = exports.default = exports.colors = void 0;
exports.getMediaQueries = getMediaQueries;
exports.stateSelectOptions = exports.scrollToHash = exports.mediaBreakpoints = exports.getTimePeriodOfDay = exports.getRawNumber = exports.getPhoneNumbers = exports.getMonth = void 0;
var _styledComponents = require("styled-components");
const colors = {
  // Primary
  "arctic-blue": {
    hex: "#0b395b",
    rgb: "11, 57, 91"
  },
  "arctic-blue-1": {
    hex: "#f5fafd",
    rgb: "245, 250, 253"
  },
  "arctic-blue-2": {
    hex: "#e1effa",
    rgb: "225, 239, 250"
  },
  "arctic-blue-4": {
    hex: "#022946",
    rgb: "2, 41, 70"
  },
  "atlantic-blue": {
    hex: "#25b5f3",
    rgb: "37, 181, 243"
  },
  "atlantic-blue-1": {
    hex: "#f5fcff",
    rgb: "245, 252, 255"
  },
  "atlantic-blue-2": {
    hex: "#e2f5fd",
    rgb: "226, 245, 253"
  },
  "atlantic-blue-3": {
    hex: "#9edefa",
    rgb: "158, 222, 250"
  },
  "atlantic-blue-4": {
    hex: "#6ecef7",
    rgb: "110, 206, 247"
  },
  "atlantic-blue-6": {
    hex: "#007ab4",
    rgb: "0, 122, 180"
  },
  "baltic-blue": {
    hex: "#031d30",
    rgb: "3, 29, 48"
  },
  "pacific-blue": {
    hex: "#0274e8",
    rgb: "2, 116, 232"
  },
  "pacific-blue-1": {
    hex: "#b1d8fe",
    rgb: "177, 216, 254"
  },
  "pacific-blue-2": {
    hex: "#3c9dfd",
    rgb: "60, 157, 253"
  },
  "pacific-blue-4": {
    hex: "#013a74",
    rgb: "1, 58, 116"
  },
  "pacific-blue-5": {
    hex: "#012a53",
    rgb: "1, 42, 83"
  },
  // Secondary
  "horizon-yellow": {
    hex: "#ffd53e",
    rgb: "255, 213, 62"
  },
  "horizon-yellow-1": {
    hex: "#fefcf6",
    rgb: "254, 252, 246"
  },
  "horizon-yellow-2": {
    hex: "#ffefb4",
    rgb: "255, 239, 180"
  },
  "horizon-yellow-3": {
    hex: "#ffea9d",
    rgb: "255, 234, 157"
  },
  "horizon-yellow-4": {
    hex: "#ffdc60",
    rgb: "255, 220, 96"
  },
  "horizon-yellow-6": {
    hex: "#fdc600",
    rgb: "253, 198, 0"
  },
  "palm-green": {
    hex: "#1cc0a5",
    rgb: "28, 192, 165"
  },
  "palm-green-1": {
    hex: "#e8faf6",
    rgb: "232, 250, 246"
  },
  "palm-green-2": {
    hex: "#d5f6ee",
    rgb: "213, 246, 238"
  },
  "palm-green-3": {
    hex: "#60e9c9",
    rgb: "96, 233, 201"
  },
  "palm-green-5": {
    hex: "#077577",
    rgb: "7, 117, 119"
  },
  "palm-green-6": {
    hex: "#055461",
    rgb: "5, 84, 97"
  },
  "sunset-orange": {
    hex: "#e86143",
    rgb: "232, 97, 67"
  },
  "sunset-orange-1": {
    hex: "#fef9ef",
    rgb: "254, 249, 239"
  },
  "sunset-orange-2": {
    hex: "#ffcc9f",
    rgb: "255, 204, 159"
  },
  "sunset-orange-3": {
    hex: "#ffa979",
    rgb: "255, 169, 121"
  },
  "sunset-orange-4": {
    hex: "#ff8255",
    rgb: "255, 130, 85"
  },
  "sunset-orange-6": {
    hex: "#bd432b",
    rgb: "189, 67, 43"
  },
  "thistle-purple": {
    hex: "#8453e6",
    rgb: "132, 83, 230"
  },
  "thistle-purple-1": {
    hex: "#f4effd",
    rgb: "244, 239, 253"
  },
  "thistle-purple-2": {
    hex: "#d2c1f6",
    rgb: "210, 193, 246"
  },
  "thistle-purple-3": {
    hex: "#a682ed",
    rgb: "166, 130, 237"
  },
  "thistle-purple-5": {
    hex: "#6325e0",
    rgb: "99, 37, 224"
  },
  "thistle-purple-6": {
    hex: "#3f1592",
    rgb: "63, 21, 146"
  },
  // Grey
  "ice-grey-1": {
    hex: "#f7fafc",
    rgb: "247, 250, 252"
  },
  "grey-2": {
    hex: "#edf2f7",
    rgb: "237, 242, 247"
  },
  "grey-3": {
    hex: "#e2e8f0",
    rgb: "226, 232, 240"
  },
  "grey-4": {
    hex: "#cbd2dd",
    rgb: "203, 210, 221"
  },
  "bottlenose-grey-5": {
    hex: "#75808f",
    rgb: "117, 128, 143"
  },
  "dusky-grey-6": {
    hex: "#5c6677",
    rgb: "92, 102, 119"
  },
  "pilot-grey-7": {
    hex: "#2d3748",
    rgb: "45, 55, 72"
  },
  "orca-grey-8": {
    hex: "#1a202c",
    rgb: "26, 32, 44"
  }
};

// @Media
exports.colors = colors;
const mediaBreakpoints = {
  tablet: 950,
  mobile: 600,
  desktop: 1440
};
exports.mediaBreakpoints = mediaBreakpoints;
function getMediaQueries(size = mediaBreakpoints) {
  const above = Object.keys(size).reduce((acc, label) => {
    acc[label] = (...args) => (0, _styledComponents.css)(["@media (min-width:", "px){", ";}"], size[label] + 1, (0, _styledComponents.css)(...args));
    return acc;
  }, {});
  const below = Object.keys(size).reduce((acc, label) => {
    acc[label] = (...args) => (0, _styledComponents.css)(["@media (max-width:", "px){", ";}"], size[label], (0, _styledComponents.css)(...args));
    return acc;
  }, {});
  // Device supports hover
  const canHover = (...args) => (0, _styledComponents.css)(["@media (hover:hover){", "}"], (0, _styledComponents.css)(...args));
  return {
    above,
    below,
    canHover
  };
}

// Phone utils
const formatPhoneNumber = phoneNumberString => {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return phoneNumberString;
};
exports.formatPhoneNumber = formatPhoneNumber;
const getPhoneNumbers = contactInfo => {
  var _contactInfo$mobile, _contactInfo$office;
  if (!contactInfo) return;
  let mobilePhone = contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$mobile = contactInfo.mobile) === null || _contactInfo$mobile === void 0 ? void 0 : _contactInfo$mobile.replace(/\D/g, ""),
    officePhone = contactInfo === null || contactInfo === void 0 ? void 0 : (_contactInfo$office = contactInfo.office) === null || _contactInfo$office === void 0 ? void 0 : _contactInfo$office.replace(/\D/g, "");
  let primaryPhone,
    primaryPhoneText,
    altPhone,
    altPhoneText,
    mobilePhoneText = formatPhoneNumber(contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.mobile),
    officePhoneText = formatPhoneNumber(contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.office);
  if (contactInfo !== null && contactInfo !== void 0 && contactInfo.extension) {
    officePhone = `${officePhone};${contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.extension.replace(/\D/g, "")}`;
    officePhoneText = `${officePhoneText} ext. ${contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.extension}`;
  }
  if ((contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.favoredPhone) === "mobile") {
    primaryPhone = mobilePhone;
    primaryPhoneText = mobilePhoneText;
    if (contactInfo !== null && contactInfo !== void 0 && contactInfo.office) {
      altPhone = officePhone;
      altPhoneText = officePhoneText;
    }
  } else if ((contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.favoredPhone) === "office") {
    primaryPhone = officePhone;
    primaryPhoneText = officePhoneText;
    if (contactInfo !== null && contactInfo !== void 0 && contactInfo.mobile) {
      altPhone = mobilePhone;
      altPhoneText = mobilePhoneText;
    }
  }
  return {
    altPhone,
    altPhoneText,
    primaryPhone,
    primaryPhoneText,
    officePhone,
    officePhoneText,
    mobilePhone,
    mobilePhoneText
  };
};
exports.getPhoneNumbers = getPhoneNumbers;
const getAddress = professional => {
  if (!professional) {
    // Use corporate address
    return `Atlantic+Bay+Mortgage+Group/@36.8259918,-76.0685092,17z/data=!3m1!4b1!4m8!1m2!2m1!1satlantic+bay+mortgage+group!3m4!1s0x89baeab9514c932f:0xbaa2770cb5886c70!8m2!3d36.8259918!4d-76.0663205`;
  } else {
    const address = {
      ...professional
    };
    address.street = (professional === null || professional === void 0 ? void 0 : professional.street) || (professional === null || professional === void 0 ? void 0 : professional.streetAddress);
    const street = `${address.street},`;
    const suite = address.suite ? ` ${address.suite},` : ``;
    const city = ` ${address.city},`;
    const state = ` ${address.state}`;
    const zip = ` ${address.zip}`;
    return street + suite + city + state + zip;
  }
};

// Date
exports.getAddress = getAddress;
const getDay = date => {
  let day;
  switch (date.getDay()) {
    case 0:
      day = "Sunday";
      break;
    case 1:
      day = "Monday";
      break;
    case 2:
      day = "Tuesday";
      break;
    case 3:
      day = "Wednesday";
      break;
    case 4:
      day = "Thurday";
      break;
    case 5:
      day = "Friday";
      break;
    case 6:
      day = "Saturday";
      break;
  }
  return day;
};
exports.getDay = getDay;
const getMonth = date => {
  let month;
  switch (date.getMonth()) {
    case 0:
      month = "January";
      break;
    case 1:
      month = "February";
      break;
    case 2:
      month = "March";
      break;
    case 3:
      month = "April";
      break;
    case 4:
      month = "May";
      break;
    case 5:
      month = "June";
      break;
    case 6:
      month = "July";
      break;
    case 7:
      month = "August";
      break;
    case 8:
      month = "September";
      break;
    case 9:
      month = "Octoboer";
      break;
    case 10:
      month = "November";
      break;
    case 11:
      month = "December";
      break;
  }
  return month;
};
exports.getMonth = getMonth;
const getDate = (date, addOrdinalSuffix = false) => {
  const dateNum = date.getDate();
  const pr = new Intl.PluralRules({
    type: "ordinal"
  });
  const ordinalSuffix = pr.select(dateNum);
  const suffixes = {
    one: "st",
    two: "nd",
    few: "rd",
    other: "th"
  };
  return `${dateNum}${addOrdinalSuffix ? suffixes[ordinalSuffix] : ``}`;
};
exports.getDate = getDate;
const getTimePeriodOfDay = date => {
  const hours = date.getHours();
  if (hours < 12) return "morning";
  if (hours < 16) return "afternoon";
  if (hours < 20) return "evening";
  return "night";
};

// Gatsby
exports.getTimePeriodOfDay = getTimePeriodOfDay;
const scrollToHash = ({
  hash
}) => {
  if (hash) {
    // Use timeout so the scroll will fire properly in chromium browsers
    setTimeout(() => {
      const scrollToElement = document.querySelector(hash);
      if (scrollToElement) scrollToElement.scrollIntoView();
    }, 100);
  }
};

// Contentful
exports.scrollToHash = scrollToHash;
const getFieldValue = (type, fieldNode, fields, allNodes) => {
  if (!fieldNode) return null;
  const addRequiredFields = entry => {
    const entryObject = {};
    fields === null || fields === void 0 ? void 0 : fields.forEach(field => {
      // If field is a nested field (e.g. file.url)
      if (field.match(/\./g)) {
        const nestedFields = field.split(".");
        let currentField = entry;
        for (let i = 0; i < nestedFields.length; i++) {
          const nestedField = nestedFields[i];
          currentField = currentField[nestedField];
          if (i < nestedFields.length - 1) {
            if (i === 0) entryObject[nestedField] = {};else entryObject[nestedFields[i - 1]] = {};
          } else {
            entryObject[nestedFields[i - 1]][nestedField] = currentField;
          }
        }
      } else {
        entryObject[field] = entry[field];
      }
      return entryObject;
    });
    return entryObject;
  };
  // If field is an array
  if (Array.isArray(fieldNode)) {
    return allNodes.filter(contentfulEntry => {
      return fieldNode.includes(contentfulEntry.id) && contentfulEntry.internal.type === type;
    }).map(entry => {
      return addRequiredFields(entry);
    });
  }
  const entry = allNodes.find(contentfulEntry => contentfulEntry.id === fieldNode && contentfulEntry.internal.type === type);
  return addRequiredFields(entry);
};

// Forms
exports.getFieldValue = getFieldValue;
const getRawNumber = value => {
  let newValue = typeof value === "string" ? value.replace(/[\s%$,]/g, "") : value;
  let rawNumber = value.toString().match(".") ? parseFloat(newValue) : parseInt(newValue);
  return rawNumber;
};
exports.getRawNumber = getRawNumber;
const stateSelectOptions = [{
  value: "AL",
  text: "AL"
}, {
  value: "AK",
  text: "AK"
}, {
  value: "AZ",
  text: "AZ"
}, {
  value: "AR",
  text: "AR"
}, {
  value: "CA",
  text: "CA"
}, {
  value: "CO",
  text: "CO"
}, {
  value: "CT",
  text: "CT"
}, {
  value: "DE",
  text: "DE"
}, {
  value: "DC",
  text: "DC"
}, {
  value: "FL",
  text: "FL"
}, {
  value: "GA",
  text: "GA"
}, {
  value: "HI",
  text: "HI"
}, {
  value: "ID",
  text: "ID"
}, {
  value: "IL",
  text: "IL"
}, {
  value: "IN",
  text: "IN"
}, {
  value: "IA",
  text: "IA"
}, {
  value: "KS",
  text: "KS"
}, {
  value: "KY",
  text: "KY"
}, {
  value: "LA",
  text: "LA"
}, {
  value: "ME",
  text: "ME"
}, {
  value: "MD",
  text: "MD"
}, {
  value: "MA",
  text: "MA"
}, {
  value: "MI",
  text: "MI"
}, {
  value: "MN",
  text: "MN"
}, {
  value: "MS",
  text: "MS"
}, {
  value: "MO",
  text: "MO"
}, {
  value: "MT",
  text: "MT"
}, {
  value: "NC",
  text: "NC"
}, {
  value: "ND",
  text: "ND"
}, {
  value: "NE",
  text: "NE"
}, {
  value: "NV",
  text: "NV"
}, {
  value: "NH",
  text: "NH"
}, {
  value: "NJ",
  text: "NJ"
}, {
  value: "NM",
  text: "NM"
}, {
  value: "NY",
  text: "NY"
}, {
  value: "OH",
  text: "OH"
}, {
  value: "OK",
  text: "OK"
}, {
  value: "OR",
  text: "OR"
}, {
  value: "PA",
  text: "PA"
}, {
  value: "RI",
  text: "RI"
}, {
  value: "SC",
  text: "SC"
}, {
  value: "SD",
  text: "SD"
}, {
  value: "TN",
  text: "TN"
}, {
  value: "TX",
  text: "TX"
}, {
  value: "UT",
  text: "UT"
}, {
  value: "VA",
  text: "VA"
}, {
  value: "VT",
  text: "VT"
}, {
  value: "WA",
  text: "WA"
}, {
  value: "WV",
  text: "WV"
}, {
  value: "WI",
  text: "WI"
}, {
  value: "WY",
  text: "WY"
}];
exports.stateSelectOptions = stateSelectOptions;
var _default = {
  colors,
  mediaBreakpoints,
  stateSelectOptions,
  getMediaQueries,
  formatPhoneNumber,
  getPhoneNumbers,
  getAddress,
  getDate,
  getDay,
  getMonth,
  getTimePeriodOfDay,
  scrollToHash,
  getFieldValue,
  getRawNumber
};
exports.default = _default;